import { render } from "./ConfiguracaoRede.vue?vue&type=template&id=52e5befe"
import script from "./ConfiguracaoRede.vue?vue&type=script&lang=js"
export * from "./ConfiguracaoRede.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__